import { gql } from "@apollo/client";

export const AGREGAR_BANCO = gql`
  mutation AGREGAR_BANCO($input: InputBanco) {
    agregarBanco(input: $input)
  }
`;

export const LISTAR_BANCOS = gql`
  query LISTAR_BANCOS {
    obtenerListaBancos {
      id
      banco
      nocuenta
      clabe
      montoapertura
    }
  }
`;

export const EDITAR_BANCO = gql`
  mutation EDITAR_BANCOS($input: InputBanco) {
    editarBanco(input: $input)
  }
`;

export const DETALLE_BANCO = gql`
  query OBTENER_DETALLE_BANCO($id: ID!) {
    obtenerDetalleBanco(id: $id) {
      id
      banco
      nocuenta
      clabe
    }
  }
`;

export const LISTAR_MOV_BANCARIOS = gql`
  query LISTAR_MOV_BANCARIOS($id: ID!) {
    listarMovimientosBancarios(id: $id) {
      id
      noOperacion
      operacion
      tipoOperacion
      montoOperacion
      fechaOperacion
      cuentaId
      devengado
      eliminado
    }
  }
`;

export const CREAR_MOV_BANCARIOS = gql`
  mutation CREAR_MOV_BANCARIO($input: InputDetalleMovBanco) {
    agregarMovBancario(input: $input)
  }
`;

export const LISTAR_SUBTIPO_EGRESO = gql`
  query OBTENER_CONCEPTOS($id: ID) {
    obtenerConceptoBanco(id: $id) {
      id
      TipoConceptoId
      concepto
    }
  }
`;

export const LISTAR_SUBTIPO_EGRESOS = gql`
  query OBTENER_CONCEPTOSB {
    obtenerConceptoBancos {
      id
      TipoConceptoId
      concepto
    }
  }
`;

export const AGREGAR_CONCEPTOBANCARIO = gql`
  mutation CREAR_CONCEPTOBANCARIO($input: InputConceptoBanco) {
    agregarConceptoBanco(input: $input)
  }
`;

export const OBENER_CONCEPTOBANCARIO_EDIT = gql`
  query OBTENER_CONCEPTOBANCARIO_EDIT($id: ID!) {
    obtenerConceptoBancosEdit(id: $id) {
      id
      TipoConceptoId
      concepto
    }
  }
`;

export const EDITAR_CONCEPTOS_BANCO = gql`
  mutation EDITAR_CONCEPTOS_BANCO($input: InputConceptoBanco) {
    EditarConceptoBanco(input: $input)
  }
`;

export const CANCELAR_MOV_BANCARIO = gql`
  mutation CANCELAR_MOV_BANCARIO($id: ID) {
    cancelarOperacionBancaria(id: $id)
  }
`;

export const FLUJO_DE_CAJA = gql`
  query OBTENER_FLUJO_CAJA {
    obtenerFlujoCaja {
      id_flujo
      periodo
      saldo_inicial
      ingresos
      egresos
      saldo_final
    }
  }
`;

export const ACTUALIZAR_FLUJO_CAJA = gql`
  mutation ACTUALIZAR_FLUJO_CAJA($input: InputFlujoCaja) {
    actualizarSaldoInicial(input: $input)
  }
`;

export const AGREGAR_FLUJO_CAJA = gql`
  mutation AGREGAR_FLUJO_CAJA($periodo: String, $saldo_inicial: Float) {
    crearSaldoInicial(periodo: $periodo, saldo_inicial: $saldo_inicial)
  }
`;
